import React from 'react';
import PropTypes from 'prop-types';
import classnames from 'classnames';
import './DropdownMenu.scss';

export default class DropdownMenu extends React.Component {
  constructor(props) {
    super(props);

    this.hideDropdown = this.hideDropdown.bind(this);
  }

  componentDidMount() {
    window.addEventListener('click', this.hideDropdown);
  }

  componentWillUnmount() {
    window.removeEventListener('click', this.hideDropdown);
  }

  getPositionClass() {
    switch (this.props.position) {
      case 'tl':
        return 'top-left';

      case 'tc':
        return 'top-center';

      case 'bc':
        return 'bottom-center';
      case 'br':
        return 'bottom-right';
      case 'bl':
        return 'bottom-left';
      case 'bcz':
        return 'bottom-center-zero';
      case 'brc':
        return 'bottom-right-center';
      case 'rc':
        return 'right-center';
      case 'tr':
      default:
        return 'top-right';
    }
  }

  hideDropdown(event) {
    if (
      this.props.searchref &&
      this.props.searchref.current &&
      this.props.searchref.current.contains(event.target)
    )
      return;
    if (!this.props.visibility || !this.props.onVisibilityChange) return;
    if (
      !(event.target.type === 'checkbox' || event.target.tagName === 'LABEL')
    ) {
      this.props.onVisibilityChange(false);
    }
  }

  render() {
    const positionClass = this.getPositionClass();

    return (
      <div
        className={classnames(
          'dropdown-menu',
          positionClass,
          this.props.className,
          { open: this.props.visibility },
        )}
      >
        {this.props.children}
      </div>
    );
  }
}

DropdownMenu.defaultProps = {
  visibility: false,
  children: [],
  position: 'tr',
  className: '',
  onVisibilityChange: () => {},
};

DropdownMenu.propTypes = {
  visibility: PropTypes.bool,
  onVisibilityChange: PropTypes.func,
  children: PropTypes.node,
  position: PropTypes.oneOf(['tr', 'tl', 'tc']),
  className: PropTypes.string,
};
